import { render, staticRenderFns } from "./BulkPriceModal.vue?vue&type=template&id=1ef6ca94&scoped=true"
import script from "./BulkPriceModal.vue?vue&type=script&lang=js"
export * from "./BulkPriceModal.vue?vue&type=script&lang=js"
import style0 from "./BulkPriceModal.vue?vue&type=style&index=0&id=1ef6ca94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef6ca94",
  null
  
)

export default component.exports